module.exports = __webpack_public_path__ + "img/pictoPeople1.db4122e7.svg";